// Acquisition-survey eligibility (Lily 2026-09-01): the survey is only for
// accounts younger than ONE DAY. Established members would be surprised by
// the form and are unlikely to answer with a useful choice, so they are
// never asked - even if they have no user_acquisition_sources doc.

export const SURVEY_ACCOUNT_AGE_LIMIT_MS = 24 * 60 * 60 * 1000;

/**
 * @param {string|undefined} creationTime - Firebase Auth
 *   user.metadata.creationTime (RFC 2822 string). Missing or unparseable
 *   counts as an OLD account: skipping a survey is cheaper than surprising
 *   an established member with one.
 * @param {number} [now] - override for tests.
 */
export const isWithinSurveyWindow = (creationTime, now = Date.now()) => {
  const createdMs = Date.parse(creationTime ?? '');
  return Number.isFinite(createdMs) && now - createdMs < SURVEY_ACCOUNT_AGE_LIMIT_MS;
};
